export {default} from './CabBanner.connect';
